import axios from "axios";
import { getEquipmentNameList } from "../Actions/helpersAPI";

import API from "../helpers/api";
let searchData = {
   VendorName: "",
    Equipment: "",
    Zone: "",
    country: "",
    port: "",
    PageNumber: 1,
    PageSize: 20,
}

export const getSearchVendorOptionsList = (item) => {
    let url = `${API.getVendorOptionList}?EquipmentName=${item.Equipment}&PortName=${item.port}&CountryName=${item.country}&Zone=${item.Zone}&VendorName=${item.VendorName}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getSearchVendorEquipmentListSuccess",
                    data: response.data.equipmentNames,
                })
                dispatch({
                    type: "getSearchVendorVendorsListSuccess",
                    data: response.data.vendorNames,
                })
                dispatch({
                    type: "getSearchVendorCountryListSuccess",
                    data: response.data.countryNames,
                })
                dispatch({
                    type: "getSearchVendorPortListSuccess",
                    data: response.data.portNames,
                })
                dispatch({
                    type: "getSearchVendorZoneListSuccess",
                    data: response.data.zones,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getVendorListFailure",
                    error: "ERROR"
                })
            })
    }
}


export const getZoneList = () => {
    let url = `${API.getZoneList}`;
      return (dispatch) => {
        axios
          .get(url)
          .then((response) => {
            dispatch({
              type: "getZoneListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getZoneListSuccess",
              error: "ERROR",
            });
          });
      };
};
export const getUnitList = () => {
    let url = `${API.getUnitList}`;
      return (dispatch) => {
        axios
          .get(url)
          .then((response) => {
            dispatch({
              type: "getUnitListSuccess",
              data: response.data,
            });
          })
          .catch((error) => {
            dispatch({
              type: "getUnitListSuccess",
              error: "ERROR",
            });
          });
      };
};
export const getVendorEquipmentList = (item) => {
    let url = `${API.getVendorEquipmentList}?EquipmentID=${item}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getVendorEquipmentListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getVendorEquipmentListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getVendorList = (item) => {
    
    let url = `${API.getVendorList}?EquipmentName=${item.Equipment}&PortName=${item.port}&CountryName=${item.country}&Zone=${item.Zone}&VendorName=${item.VendorName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getVendorListSuccess",
                    data: response.data,
                })
                dispatch(getEquipmentNameList());
                dispatch(getZoneList());
            })
            .catch((error) => {
                dispatch({
                    type: "getVendorListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const postVendorDetails = (data) => {
    let url = `${API.postVendor}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                dispatch(getVendorList(searchData));
                dispatch({
                    type: "postVendorDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postVendorDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putVendorDetails = (data) => {
    let url = `${API.postVendor}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch(getVendorList(searchData));
                dispatch({
                    type: "putVendorDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putVendorDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteVendorDetails = (data) => {
    let url = `${API.deleteVendor}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch(getVendorList(searchData));
                dispatch({
                    type: "deleteVendorDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteVendorDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
